module.exports = __webpack_public_path__ + "static/media/logo_w.5fb0c51d.webp";